globalThis.Profile = class Profile {
  constructor(data = {}) {
    Object.assign(this, data);
    this.name = this.name || "Player";
    this.id = this.id || uid();
  }
};
